const appdevteam = [
    {
        name: "Het Nakhua",
        title: "App Dev",
        imageSrc: "/images/committee/app-dev/Het_Nakhua.jpg",
        socials:{},
    },
    {
        name: "Neel Kothari",
        title: "App Dev",
        imageSrc: "/images/committee/app-dev/Neel_Kothari.jpeg",
        socials: {},
    },
    {
        name: "Vatsal Shah",
        title: "App Dev",
        imageSrc: "/images/committee/app-dev/Vatsal_Shah.jpg",
        socials:{},
    },
    
]

export default appdevteam;